/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloseSquare = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M23 1v22H1V1zm-2 2H3v18h18zm-5.502 4L17 8.502 13.502 12 17 15.498 15.498 17 12 13.502 8.502 17 7 15.498 10.498 12 7 8.502 8.502 7 12 10.498z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCloseSquare as CloseSquare };
